import { ScrollArea } from "@arcadeai/design-system/components/ui/atoms/scroll-area";
import { Separator } from "@arcadeai/design-system/components/ui/atoms/separator";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@arcadeai/design-system/components/ui/atoms/sheet";
import { useState } from "react";
import type { Tool } from "@/app/tools/types";
import { ToolDetails } from "./tool-details";

type ToolDetailsSheetProps = {
  tool: Tool;
  trigger: React.ReactElement;
};

export const ToolDetailsSheet = ({ tool, trigger }: ToolDetailsSheetProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasScopes = Boolean(
    tool.requirements?.authorization?.oauth2?.scopes?.length
  );

  return (
    <Sheet onOpenChange={setIsOpen} open={isOpen}>
      <SheetTrigger render={trigger} />
      <SheetContent className="w-full px-2">
        <ScrollArea className="h-full w-full">
          <SheetHeader>
            <SheetTitle className="mt-4">{tool.name}</SheetTitle>
            <SheetDescription className="whitespace-pre-wrap text-sm">
              {tool.description}
            </SheetDescription>
          </SheetHeader>
          <div className="mt-4 h-full px-4">
            <Separator className="mt-4 mb-6" />
            <ToolDetails hasScopes={hasScopes} tool={tool} />
          </div>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
};
